import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Loading from "./components/structures/Loading";
import Header from "./components/structures/Header";
import Landing from "./components/pages/landing";
import Reservation from "./components/pages/reservation";
import Mantos from "./components/pages/mantos";
import BookingPage from "./components/pages/booking";
import PaymentPage from "./components/pages/payment";
import SuccessPage from "./components/pages/booking/success";
import PendingPage from "./components/pages/booking/pending";
import FailedPage from "./components/pages/booking/failed";


import { forceResponsive, handleOrientationChange, detectDesktopModeOnMobile } from "./utils/forceResponsive";

const LOADING_DURATION_MS = 3000;

const AppContent = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  const handleLoadingComplete = () => {
    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(true);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    forceResponsive();
    handleOrientationChange();
    detectDesktopModeOnMobile();
    
    setTimeout(() => {
      forceResponsive();
      detectDesktopModeOnMobile();
    }, 500);
  }, []);

  return (
    <div className="App">
      {isLoading && (
        <Loading
          key={location.pathname}
          duration={LOADING_DURATION_MS}
          onLoadingComplete={handleLoadingComplete}
        />
      )}
      <div style={{ display: isLoading ? 'none' : 'block' }}>
        <Header />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/reservation" element={<Reservation />} />
          <Route path="/mantos" element={<Mantos />} />
          <Route path="/mantos/booking" element={<BookingPage />} />
          <Route path="/mantos/booking/payment" element={<PaymentPage />} />
          <Route path="/mantos/booking/success" element={<SuccessPage />} />
          <Route path="/mantos/booking/pending" element={<PendingPage />} />
          <Route path="/mantos/booking/failed" element={<FailedPage />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/booking/payment" element={<PaymentPage />} />
          <Route path="/booking/success" element={<SuccessPage />} />
          <Route path="/booking/pending" element={<PendingPage />} />
          <Route path="/booking/failed" element={<FailedPage />} />
        </Routes>
      </div>
    </div>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
};

export default App;